import { Box } from "@mui/material";
import { styled } from "@mui/material";

export const ItemLetter = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: "3.5vh",
  fontFamily: "Cabin, sans-serif",
  fontWeight: 900,
  cursor: "pointer",
  textShadow: `1.5px 1.5px #FFF`,
  padding: "0.1vw 2vw ",
  textAlign: "left",
}));

export const ItemWord = styled(Box)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: "3.5vh",
  fontFamily: "Cabin, sans-serif",
  fontWeight: 900,
  cursor: "pointer",
  textShadow: `1.5px 1.5px #FFF`,
  padding: "0.1vw 2vw ",
  textAlign: "left",
}));
